var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbaseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9781 33.9331C52.7359 39.1194 50.4863 44.0081 46.7051 47.5659C42.9238 51.1237 37.9072 53.0716 32.7158 52.9979C27.5245 52.9241 22.5652 50.8345 18.8866 47.1707C15.2079 43.5069 13.0981 38.5562 13.0033 33.3652C12.9085 28.1742 14.8361 23.1497 18.3785 19.354C21.9209 15.5584 26.8005 13.289 31.9858 13.0257C37.171 12.7625 42.2554 14.5259 46.164 17.9432C50.0727 21.3606 52.4993 26.1639 52.9307 31.3379L43.2089 32.1486C42.9879 29.4984 41.7449 27.038 39.7429 25.2876C37.7408 23.5372 35.1364 22.6339 32.4805 22.7688C29.8245 22.9036 27.325 24.066 25.5106 26.0102C23.6961 27.9545 22.7087 30.5281 22.7573 33.187C22.8058 35.846 23.8865 38.3818 25.7708 40.2585C27.6551 42.1352 30.1953 43.2055 32.8544 43.2433C35.5135 43.2811 38.0832 42.2833 40.02 40.4609C41.9568 38.6386 43.1091 36.1344 43.2332 33.4779L52.9781 33.9331Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseLogo);
export default __webpack_public_path__ + "static/media/coinbaseLogo.926d954a300b9adcef41a907e04b2f2b.svg";
export { ForwardRef as ReactComponent };